import styled from 'styled-components';
import { SpaceProps, space } from 'styled-system';

export type BaseStyleProps = SpaceProps;

export default styled.ul.attrs(() => ({
  role: 'menu'
}))<BaseStyleProps>`
  ${({ theme }) => `
    overflow-y: auto;
    list-style: none;
    padding: 0;
    margin: 0;
  `}
  ${space}
`;

interface IconWrapperProps extends SpaceProps {
  /**
   * If an item within this sub nav is active or not
   */
  active?: boolean;
  /**
   * If SubNav shows only icon
   */
  iconOnlyMode?: boolean;
  /**
   * If this item is disabled
   */
  disabled?: boolean;
}

export const IconWrapper = styled.span<IconWrapperProps>`
  ${({ theme, iconOnlyMode, disabled }) => `
    padding-left: ${iconOnlyMode ? theme.space[0] : theme.space[4]}px;
    color: ${theme.uptimeColors.grayScales.white};
  `}
  ${space}
`;

interface ChevronProps {
  /**
   * Whether the component is expanded or not
   */
  expanded?: boolean;
}

export const ChevronWrapper = styled.div<ChevronProps>`
  ${({ theme, expanded }) => `
    display: flex;
    color: ${theme.uptimeColors.grayScales.white};
    ${expanded ? 'transform: rotate(180deg)' : 'transform: rotate(0deg)'};
  `}
`;

export const StyledListItem = styled.li<SpaceProps>`
  ${space}
`;

interface StyledItemProps extends SpaceProps {
  /**
   * Whether the component is expanded or not
   */
  expanded?: boolean;
  /**
   * Sets disabled styles for nav item
   */
  disabled?: boolean;
  /**
   * If icon is provided by the user
   */
  withIcon?: boolean;
  /**
   * If shows only icon
   */
  iconOnlyMode?: boolean;

  hasSubMenu?: boolean;

  level?: number;
}

/* eslint-disable no-nested-ternary */
export const NavItem = styled.div<StyledItemProps>`
  ${({ theme, disabled, expanded, iconOnlyMode, hasSubMenu, level = 0 }) => `
    align-items: center;
    justify-content: ${iconOnlyMode ? 'center' : (hasSubMenu ? 'space-between' : 'start')};
    display: flex;
    padding: ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[4]}px ${theme.uptimeSpace[6]}px ${theme.uptimeSpace[8]}px;
    margin-left: ${theme.uptimeSpace[14] * level}px;
    list-style: none;
    user-select: none;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
    background-color: ${expanded ? theme.uptimeColors.mainTheme.secondary : 'transparent'};
    
    ${
      disabled
        ? ''
        : `&:hover {
            background-color: ${theme.uptimeColors.mainTheme.secondary};
          }`
    }

    &:focus {
      outline: none;
    }
  `}
  ${space}
`;